import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseDataResponse, BaseEntityResponse, LoginParams, WebAPILoginResponse, BaseResponse, CredentialActivityStatus,
     PasswordRecoveryParams, CredentialExternalInfo, WebAPICredentialInfo, 
     CredentialCheckResponse, SaveCredentialsParams, CredentialsCheckResponse } from "@base/entities/BaseEntities";
import { APIGatewayService } from "../gateway/APIGateway.service";
import { BaseEndpoint } from "@base/endpoint/BaseEndpoint";
import { EnumNotificationDeliveryOptions, EnumMFAMethods } from "../framework/sysenums.enum";


@Injectable()
export class LoginEndpoint extends BaseEndpoint
{
    //Constructor
    constructor(api: APIGatewayService)
    {
        super("Login", api);
    }

    public Login(Params: LoginParams): Observable<BaseEntityResponse<WebAPILoginResponse>>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'Login', Params);
    }

    public ChangePasswordExpired(Params: LoginParams): Observable<CredentialsCheckResponse>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'ChangePasswordExpired', Params);
    }

    public Logout(): Observable<BaseResponse>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'Logout');
    }
       
    public VerifyPasswordComplexity(Params: LoginParams): Observable<BaseResponse>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'VerifyPasswordComplexity', Params);
    }

    public ChangePassword(Params: LoginParams): Observable<BaseResponse>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'ChangePassword', Params);
    }

    public RecoverPassword(Params: PasswordRecoveryParams): Observable<BaseResponse>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'RecoverPassword', Params);
    }

    public VerifyRecoveryToken(Params: PasswordRecoveryParams): Observable<BaseResponse>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'VerifyRecoveryToken', Params);
    }

    public ChangePasswordByToken(Params: PasswordRecoveryParams): Observable<BaseResponse>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'ChangePasswordByToken', Params);
    }

    public SendOtp(Params: LoginParams): Observable<BaseResponse>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'SendOtp', Params);
    }

    public GetCredentialInfo(CredentialID: number, CredentialType: number): Observable<BaseDataResponse<WebAPICredentialInfo>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetCredentialInfo', { CredentialID: CredentialID, CredentialType: CredentialType });
    }

    public GetExternalInfo(CredentialID: number, CredentialType: number): Observable<BaseEntityResponse<CredentialExternalInfo>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetExternalInfo', { CredentialID: CredentialID, CredentialType: CredentialType });
    }

    public GenerateRandomPassword(): Observable<BaseDataResponse<string>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GenerateRandomPassword');
    }

    public GetOAuthRedirectURL(ReturnURL: string): Observable<BaseDataResponse<string>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetOAuthRedirectURL', {ReturnURL: ReturnURL});
    }

    public SaveCredentials(params: SaveCredentialsParams) {
        return this.api.ExecutePostAction(this.ControllerName, 'SaveCredentials', params);
    }

    public SetCredentialIsActive(CredentialID: number, IsActive: boolean): Observable<BaseResponse>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'SetCredentialIsActive', { CredentialID: CredentialID, IsActive: IsActive });
    }

    public UnlockCredentials(CredentialID: number): Observable<BaseResponse>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'UnlockCredentials', { CredentialID: CredentialID });
    }

    public WelcomeUser(CredentialID: number, DeliveryOptions: EnumNotificationDeliveryOptions, Address: string,Language: string): Observable<BaseResponse>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'WelcomeUser', { CredentialID: CredentialID, DeliveryOptions: DeliveryOptions, Address: Address, Language: Language});
    }

    public CheckUserName(Params: LoginParams): Observable<BaseEntityResponse<CredentialCheckResponse>>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'CheckUserName', Params);
    }

    public ChangeLanguage(Language: string): Observable<BaseResponse>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'ChangeLanguage', { Language: Language});
    }

    public ImpersonateLogin(credentialID: number): Observable<BaseEntityResponse<WebAPILoginResponse>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'ImpersonateLogin', { credentialID: credentialID });
    }
}
